// Hosts IPX may fetch from, consumed by nuxt.config.ts (image.domains). Unlisted hosts
// need no guard: @nuxt/image returns them untouched, which is what dev relies on.
export const IMAGE_DOMAINS = ['cdn.miio.com', 'miio-prod-shop-images.s3.eu-south-2.amazonaws.com', 'miio-prod-website.s3.eu-south-2.amazonaws.com', 'miio-prod-marketing.s3.eu-south-2.amazonaws.com']

// SVG is the one case IPX does not wave through — it rasterizes the vector
export function isSvg(src: unknown): boolean {
  if (typeof src !== 'string' || !src) return false
  try {
    return new URL(src, 'https://miio.com').pathname.toLowerCase().endsWith('.svg')
  } catch {
    return false
  }
}
